export default {
  PAY_PASTDUE_AND_NEXT_INSTALLMENT: 'checkout.lib.components.paymentOption.payPastdueAndNextInstallment',
  PAY_NEXT_INSTALLMENT: 'checkout.lib.components.paymentOption.payNextInstallment',
  PAY_REMAINING_BALANCE: 'checkout.lib.components.paymentOption.payRemainingBalance',
  PAY_FAILED_PAYMENT: 'checkout.lib.components.paymentOption.payFailedpayment',
  PAY_PARTIAL_WITH_RECURRING: '',
  PAY_PAST_DUE: 'checkout.lib.components.paymentOption.payAmountDue',
  PAY_CUSTOM_AMOUNT: 'checkout.lib.components.paymentOption.payCustomAmount',
  PAY_DEPOSIT_WITH_PAYMENT_PLAN: 'checkout.lib.components.paymentOption.payDeposit',
  PAY_LATER: 'checkout.lib.components.paymentOption.payLater',
};
